var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bonus-send-table-pane" },
    [
      _c("div", { staticClass: "page-header" }, [
        _c("div", { staticClass: "page-title" }, [
          _vm._v("\n      优惠券发放管理\n    "),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "header-actions" },
          [
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.handleAdd } },
              [_vm._v("\n        添加优惠券/套券发放\n      ")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "search-area" },
        [
          _c(
            "el-form",
            {
              staticClass: "search-form",
              attrs: { inline: true, model: _vm.searchForm },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "250px" },
                    attrs: { placeholder: "请输入标题", clearable: "" },
                    model: {
                      value: _vm.searchForm.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "title", $$v)
                      },
                      expression: "searchForm.title",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSearch },
                    },
                    [_vm._v("\n          查询\n        ")]
                  ),
                  _vm._v(" "),
                  _c("el-button", { on: { click: _vm.handleReset } }, [
                    _vm._v("\n          重置\n        "),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-area" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.tableLoading,
                  expression: "tableLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData, border: "" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "id",
                  label: "ID",
                  align: "center",
                  width: "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "title",
                  label: "标题",
                  align: "center",
                  "min-width": "200",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "发放类型", align: "center", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.sendType === 1
                          ? _c(
                              "el-tag",
                              { attrs: { type: "primary", size: "small" } },
                              [_vm._v("\n            优惠券\n          ")]
                            )
                          : scope.row.sendType === 4
                          ? _c(
                              "el-tag",
                              { attrs: { type: "success", size: "small" } },
                              [_vm._v("\n            套券\n          ")]
                            )
                          : _c(
                              "el-tag",
                              { attrs: { type: "info", size: "small" } },
                              [_vm._v("\n            -\n          ")]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "发放事件", align: "center", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "small",
                              type: _vm.getEventType(scope.row.event),
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.getEventName(scope.row.event)) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "用户类型", align: "center", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.userType === 0
                          ? _c(
                              "el-tag",
                              { attrs: { type: "info", size: "small" } },
                              [_vm._v("\n            所有\n          ")]
                            )
                          : scope.row.userType === 1
                          ? _c(
                              "el-tag",
                              { attrs: { type: "success", size: "small" } },
                              [_vm._v("\n            新用户\n          ")]
                            )
                          : scope.row.userType === 2
                          ? _c(
                              "el-tag",
                              { attrs: { type: "warning", size: "small" } },
                              [_vm._v("\n            老用户\n          ")]
                            )
                          : _c(
                              "el-tag",
                              { attrs: { type: "info", size: "small" } },
                              [_vm._v("\n            -\n          ")]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "企微用户", align: "center", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.isQwe === 1
                          ? _c(
                              "el-tag",
                              { attrs: { type: "success", size: "small" } },
                              [_vm._v("\n            启用\n          ")]
                            )
                          : scope.row.isQwe === 0
                          ? _c(
                              "el-tag",
                              { attrs: { type: "info", size: "small" } },
                              [_vm._v("\n            不限\n          ")]
                            )
                          : _c(
                              "el-tag",
                              { attrs: { type: "info", size: "small" } },
                              [_vm._v("\n            -\n          ")]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "优惠券", align: "center", "min-width": "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", {
                          staticClass: "bonus-display",
                          domProps: {
                            innerHTML: _vm._s(scope.row.bonusDisplay || "-"),
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "开始/结束", align: "center", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "time-range" }, [
                          _c("div", [
                            _vm._v(_vm._s(_vm.formatTime(scope.row.startTime))),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(_vm._s(_vm.formatTime(scope.row.endTime))),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "是否有效", align: "center", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-switch", {
                          attrs: { "active-value": 1, "inactive-value": 0 },
                          on: {
                            change: function ($event) {
                              return _vm.handleStatusChange(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.enabled,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "enabled", $$v)
                            },
                            expression: "scope.row.enabled",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "添加时间", align: "center", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.formatTime(scope.row.addTime)) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  align: "center",
                  width: "320",
                  fixed: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handleEdit(scope.row)
                              },
                            },
                          },
                          [_vm._v("\n            编辑\n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handleCopy(scope.row)
                              },
                            },
                          },
                          [_vm._v("\n            复制\n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handleShowRecord(scope.row)
                              },
                            },
                          },
                          [_vm._v("\n            发放记录\n          ")]
                        ),
                        _vm._v(" "),
                        scope.row.event === 2 ||
                        scope.row.event === 3 ||
                        scope.row.event === 7
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleQrcode(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n            二维码\n          ")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-area" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.currentPage,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("activity-qrcode-dialog", {
        attrs: {
          visible: _vm.qrDialogVisible,
          title: _vm.qrTitle,
          items: _vm.qrItems,
        },
        on: {
          "update:visible": function ($event) {
            _vm.qrDialogVisible = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }